import React from "react"

import Layout from "../../../components/shared/layout"
import useHeroSmokeImages from "../../../components/shared/hooks/useHeroSmokeImages"

import Hero from "../../../components/shared/hero"
import { HeroOverlay } from "../../../components/developer-tools/hero.style"
import DataExport from "../../../components/exports/data-export"
import DataModel from "../../../components/exports/data-model"
import KeyboardDivider from "../../../components/shared/keyboard-divider"
import ContactForm from "../../../components/shared/contact"
import Footer from "../../../components/shared/footer"
import SEO from "../../../components/shared/seo"
import externalLinks from "../../../external-links"

export default function ExportsPage({ location }) {
  const images = useHeroSmokeImages()
  return (
    <Layout location={location}>
      <SEO
        title="MVF Export"
        description="Our Map & Data Exports allows for custom experiences to be built with updated and highly accurate map data."
      />
      <Hero
        overlayStyle={HeroOverlay}
        title={"Mapping Exports"}
        sizes={images}
        description={
          "Mappedin’s exports take highly accurate indoor map data and format it for a variety of use cases. Along with a direct API to the Mappedin CMS, these GeoJSON based exports provide complete flexibility to build any indoor mapping experience."
        }
      />
      <DataExport />
      <DataModel />
      <KeyboardDivider
        text="Check out our Product 101: GeoJSON Exports blog to learn more"
        linkText="Read About Exports"
        linkLocation={externalLinks.hubspot.product101Export}
      />
      <ContactForm />
      <Footer />
    </Layout>
  )
}
